import { render } from "./SvgTransition.vue?vue&type=template&id=22fbe2e8&scoped=true"
import script from "./SvgTransition.vue?vue&type=script&lang=js"
export * from "./SvgTransition.vue?vue&type=script&lang=js"

import "./SvgTransition.vue?vue&type=style&index=0&id=22fbe2e8&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fbe2e8"]])

export default __exports__